export default __webpack_public_path__ + "static/media/Graphik-Extralight.86ffe48d.woff";